/**
 * @note this avatar functions when we are unable to derive an avatar in particular
 * scenarios
 */
// eslint-disable-next-line import/prefer-default-export
export const FALLBACK_AVATAR = {
  avatarId: 24,
  avatarVariantId: 108,
  version: 'v12-rc4-2025-04-18',
  // general human readable info - not for any usage in the codebase
  context: 'Selene Narration (Caruso)',
} as const;
